import { Box, Typography } from '@mui/material';

type colorProps = {
    pill: string;
};

const OverviewPills = (props: colorProps) => {
    const pills = [
        {
            name: 'HIGHEST',
            hexCode: '#E20000',
        },
        {
            name: 'HIGH',
            hexCode: '#FB7800',
        },
        {
            name: 'MEDIUM',
            hexCode: '#FEC400',
        },
        {
            name: 'LOW',
            hexCode: '#93A795',
        },
        {
            name: 'FEATURE',
            hexCode: '#A142FF',
        },
        {
            name: 'BUG',
            hexCode: '#000000',
        },
        {
            name: 'TASK',
            hexCode: '#4A00E8',
        },
        {
            name: 'BACKLOG',
            hexCode: '#515B52',
        },
        {
            name: 'ON HOLD',
            hexCode: '#747c75',
        },
        {
            name: 'TODO',
            hexCode: '#93A795',
        },
        {
            name: 'REDO',
            hexCode: '#E30000',
        },
        {
            name: 'IN PROGRESS',
            hexCode: '#FF7A00',
        },
        {
            name: 'PR',
            hexCode: '#1468B6',
        },
        {
            name: 'PR DONE',
            hexCode: '#0085FF',
        },
        {
            name: 'CANCELED',
            hexCode: '#000000',
        },
        {
            name: 'DONE',
            hexCode: '#0ED9CD',
        },
        {
            name: 'UAT READY',
            hexCode: '#00E309',
        },
        {
            name: 'UAT',
            hexCode: '#00E309',
        },
        {
            name: 'PROD READY',
            hexCode: '#00E309',
        },
        {
            name: 'PRODUCTION',
            hexCode: '#03C03C',
        },
        {
            name: 'CLOSED',
            hexCode: '#00800D',
        },
    ];

    const selectedPill = pills.filter((pill) => pill.name?.toUpperCase() == props.pill?.toUpperCase());

    return (
        <>
            {selectedPill.map((pill) => {
                return (
                    <Box
                        sx={{
                            bgcolor: `${pill.hexCode}`,
                            color: 'white',
                            px: '10px',
                            width: '70px',
                            height: '20px',
                            borderRadius: '5px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        key={pill.name}
                    >
                        <Typography fontWeight='bold' fontSize='10px' >
                            {pill.name === 'IN PROGRESS'
                                ?
                                'WIP'
                                : pill.name === 'PRODUCTION'
                                    ?
                                    'PROD'
                                    :
                                    pill.name
                            }
                        </Typography>
                    </Box>
                );
            })}
        </>
    );
};

export default OverviewPills;
